import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

/**
 * Componente para um card genérico, recebe um item, um evento do 
 * tipo `onClick` e um `className` válido.
 * 
 * O evento `onClick` receberá o valor completo de `item` ao ser 
 * executado.
 * 
 * Você pode substituir este componente por outro e modificar 
 * o conteúdo de item, mudando o comportamento do "pai".
 * 
 * @param {{
 *   item: Object,
 *   onClick?: (value: Object) => void,
 *   className?: string|string[]|{[key: string]: boolean}
 * }} props
 */
const CardListItem = React.memo(({ item, onClick, className }) => {
  const _attr = {
     onClick: () => (onClick) ? onClick(item) : console.log(item)
  };
  if (className) _attr.className = classnames(className);

  return (
    <div {..._attr}>
      <figure>
        <img src={item.urlImg} alt={""}/>
      </figure>
      <span>{item.title}</span>
      <i>{item.description}</i>
    </div>
  );
});

CardListItem.defaultProps = {
  className: null,
  onClick: null
};

CardListItem.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.objectOf(PropTypes.bool)
  ]),
  item: PropTypes.any.isRequired,
  onClick: PropTypes.func 
};

// ----------------------------------------------------------------------

/**
 * Recebe um array de objetos, retorna eles mapeados para um componente.
 * 
 * A propriedade `className` é passada diretamente para cada item de lista, 
 * assim, como cada evento `onClick`.
 * 
 * Você pode substituir o componente renderizador para `item` caso deseje, 
 * desta forma, você pode também modificar quais dados ele contém, mudando 
 * o output deste componente.
 * 
 * @param {{
 *   className?: string|string[]|{[key: string]: boolean},
 *   items?: Array<any>,
 *   itemComponent?: React.FunctionComponent<any>,
 *   onClick?: (value: Object) => void
 * }} props
 */
export const CardList = React.memo(({
  className,
  items,
  itemComponent, 
  onClick
}) => {
  const Component = (itemComponent) ? itemComponent : CardListItem;
  return items.map((item, key) => {
    return (
      <Component 
        key={key}
        className={className} 
        item={item} 
        onClick={onClick} />
    );
  });
});

CardList.defaultProps = {
  className: null,
  items: [],
  itemComponent: CardListItem,
  onClick: null
};

CardList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.objectOf(PropTypes.bool)
  ]),
  items: PropTypes.arrayOf(PropTypes.any),
  itemComponent: PropTypes.any, 
  onClick: PropTypes.func
};
